import {Image} from '@jobseeker/lotus/components/Image';

import {Box} from '@jobseeker/lotus/foundations';
import {Search, SearchOld} from '@jobseeker/lotus/assets/icons';
import {getRefTagAndOrigin, handleTracking} from '@jobseeker/common-core/utils';

const SearchBtn = (props: any) => {
  const {onClick, theme, calledFrom, handleDropClose, hideHover} = props || {};

  const {origin, refText} = getRefTagAndOrigin();

  return (
    <Box
      display="flex"
      width={calledFrom ? {xxs: '28px', sm: '33px'} : '36px'}
      height={'100%'}
      justifyContent={'center'}
      sx={{
        color: 'secondary.main',
        marginRight: hideHover
          ? {xxs: 0, md: theme.spacing(2)}
          : theme.spacing(1.125),
        ':hover': hideHover
          ? {}
          : {
              background: 'white',
              boxShadow: '6px 6px 12px 2px rgba(41, 41, 41, 0.04)',
              borderRadius: '20px',
              border: '0.10px rgba(126, 126, 126, 0.40) solid',
            },
        cursor: 'pointer',
      }}
      data-testid="search_icon"
      onClick={() => {
        setTimeout(() => {
          onClick();
          if (process.env.NEXT_PUBLIC_APP_NAME === 'hirist') {
            handleTracking('jsClickSearchBar', {
              event_category: 'Search',
              UserId: sessionStorage.getItem('userId') || 'NA',
              Device: sessionStorage.getItem('device') || 'desktop',
              Origin: origin,
              Ref: refText,
            });
          }
        }, 0);
      }}
      onMouseEnter={handleDropClose}
    >
      <Image
        src={hideHover ? SearchOld : Search}
        alt={'Search'}
        data-name="navbar-search"
        width={hideHover ? 21 : calledFrom ? 18 : 20}
        height={hideHover ? 21 : calledFrom ? 18 : 20}
        objectFit="cover"
        quality={50}
        style={{
          margin: theme.spacing(0.875),
        }}
      />
    </Box>
  );
};

export default SearchBtn;
